export default function (...args)
{
	return {
		regex: /^((?:[0-9A-Z]{1,2})(?:[,-][0-9A-Z]{1,2})*)$/,
		getValue(default_value, _this = this)
		{
			return this.safeProtoCall(default_value, _this)?.split(/[,-]/);
		},
		store_mask(match)
		{
			return match.split(/[,-]/).join(',');
		},
		display_mask(match, ...args)
		{
			return match.split(',').join('-');
		}
	};
}

